import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[NoticeType SetFilter] Action',
  ResetFilter: '[NoticeType ResetFilter] Action',
}

const initialNoticeTypeState: INoticeTypeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface INoticeTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-NoticeType', whitelist: ['filter']},
  (
    state: INoticeTypeState = initialNoticeTypeState,
    action: ActionWithPayload<INoticeTypeState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialNoticeTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
